// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as GenerateRouteImport } from './routes/generate'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as ForSlugRouteImport } from './routes/for.$slug'
import { Route as GuidesIndexRouteImport } from './routes/guides.index'
import { Route as GuidesSlugRouteImport } from './routes/guides.$slug'
import { Route as ShareTokenRouteImport } from './routes/share/$token'
import { Route as AuthenticatedDocumentsIdRouteImport } from './routes/_authenticated/documents.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const GenerateRoute = GenerateRouteImport.update({
            id: '/generate',path: '/generate',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const ForSlugRoute = ForSlugRouteImport.update({
            id: '/for/$slug',path: '/for/$slug',getParentRoute: () => rootRouteImport
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })
const ShareTokenRoute = ShareTokenRouteImport.update({
            id: '/share/$token',path: '/share/$token',getParentRoute: () => rootRouteImport
          })
const AuthenticatedDocumentsIdRoute = AuthenticatedDocumentsIdRouteImport.update({
            id: '/documents/$id',path: '/documents/$id',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedDocumentsIdRoute: AuthenticatedDocumentsIdRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,ContactRoute: ContactRoute,GenerateRoute: GenerateRoute,LoginRoute: LoginRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRoute,TermsRoute: TermsRoute,AuthCallbackRoute: AuthCallbackRoute,ForSlugRoute: ForSlugRoute,GuidesSlugRoute: GuidesSlugRoute,ShareTokenRoute: ShareTokenRoute,GuidesIndexRoute: GuidesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)